import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-facebook",
  "use": "icon-facebook-usage",
  "viewBox": "0 0 11 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 21\" id=\"icon-facebook\"><path d=\"M7.42 4.508h3.126V.758H7.42a4.38 4.38 0 0 0-4.375 4.375v1.875h-2.5v3.75h2.5v10h3.75v-10H9.92l.625-3.75h-3.75V5.133c0-.339.286-.625.625-.625Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol